import script from "./Page7.vue?vue&type=script&setup=true&lang=js"
export * from "./Page7.vue?vue&type=script&setup=true&lang=js"

import "./Page7.vue?vue&type=style&index=0&id=205a260f&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-205a260f"]])

export default __exports__